var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContextMenuAFY, icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
export var beneficiaryColumns = [
    {
        editable: false,
        field: "type",
        flex: 1,
        headerName: "Tipo beneficiario",
        width: 150,
    },
    {
        editable: false,
        field: "name",
        flex: 1,
        headerName: "Nombres",
        width: 150,
        renderCell: function (params) {
            return params.value + " " + params.row.secondName;
        },
    },
    {
        editable: false,
        field: "lastName",
        flex: 1,
        headerName: "Apellidos",
        width: 150,
        renderCell: function (params) {
            return params.value + " " + params.row.secondLastName;
        },
    },
    {
        editable: false,
        field: "phone",
        flex: 1,
        headerName: "Teléfono",
        width: 150,
    },
    {
        editable: false,
        field: "dob",
        flex: 1,
        headerName: "Fecha nacimiento",
        width: 150,
        valueGetter: function (params) {
            var date = new Date(params.value);
            var day = ("0" + date.getDate()).slice(-2);
            var month = ("0" + (date.getMonth() + 1)).slice(-2);
            var year = date.getFullYear();
            return "".concat(day, "/").concat(month, "/").concat(year);
        },
    },
    {
        editable: false,
        field: "percentage",
        flex: 1,
        headerName: "Porcentaje",
        width: 150,
        valueGetter: function (params) {
            return "".concat(params.value, " %");
        },
    },
];
export var insuredColumns = [
    {
        editable: false,
        field: "type",
        flex: 1,
        headerName: "Tipo asegurado",
        width: 150,
    },
    {
        editable: false,
        field: "name",
        flex: 1,
        headerName: "Nombres",
        width: 150,
        renderCell: function (params) {
            return params.value + " " + params.row.secondName;
        },
    },
    {
        editable: false,
        field: "lastName",
        flex: 1,
        headerName: "Apellidos",
        width: 150,
        renderCell: function (params) {
            return params.value + " " + params.row.secondLastName;
        },
    },
    {
        editable: false,
        field: "marriedName",
        flex: 1,
        headerName: "Apellido de casada",
        width: 150,
    },
    {
        editable: false,
        field: "phone",
        flex: 1,
        headerName: "Teléfono",
        width: 150,
    },
    {
        editable: false,
        field: "dob",
        flex: 1,
        headerName: "Fecha nacimiento",
        width: 150,
        valueGetter: function (params) {
            var date = new Date(params.value);
            var day = ("0" + date.getDate()).slice(-2);
            var month = ("0" + (date.getMonth() + 1)).slice(-2);
            var year = date.getFullYear();
            return "".concat(day, "/").concat(month, "/").concat(year);
        },
    },
];
export var Breadcrum = [
    {
        name: "Producto",
        key: "seguro",
        ariaCurrent: "",
    },
    {
        name: "Plan",
        key: "plan",
        ariaCurrent: "",
    },
    {
        name: "Registro",
        key: "registro",
        ariaCurrent: "",
    },
];
export var Columns = function (handleClickContextMenu) {
    return [
        {
            field: "actions",
            headerName: "",
            width: 80,
            renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "transparent", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                        {
                            disabled: false,
                            icon: {
                                color: "#006ac6",
                                icon: icons.PermIdentity,
                                size: sizesIcon.standard,
                            },
                            id: "1",
                            name: "Beneficiarios",
                        },
                        {
                            disabled: false,
                            icon: {
                                color: "#006ac6",
                                icon: icons.PermIdentity,
                                size: sizesIcon.standard,
                            },
                            id: "2",
                            name: "Asegurados",
                        },
                        {
                            disabled: false,
                            icon: {
                                color: "#006ac6",
                                icon: icons.Search,
                                size: sizesIcon.standard,
                            },
                            id: "3",
                            name: "Ver detalles",
                        },
                        {
                            disabled: params.row.estado === "Cancelada" ||
                                params.row.estado === "cancelada" ||
                                params.row.estado === "Expirada" ||
                                params.row.estado === "expirada",
                            icon: {
                                color: (params.row.estado === "Cancelada" ||
                                    params.row.estado === "cancelada" ||
                                    params.row.estado === "Expirada" ||
                                    params.row.estado === "expirada") ? "#cccccc" : "#d32f2f",
                                icon: icons.Cancel,
                                size: sizesIcon.standard,
                            },
                            id: "4",
                            name: "Cancelar",
                        },
                    ], onClickContextMenu: function (item) {
                        return handleClickContextMenu(item, params);
                    }, sizeIcon: sizesIcon.standard }) }))); },
        },
        {
            editable: false,
            field: "estado",
            flex: 1,
            headerName: "Estado",
            renderCell: function (params) { return (_jsxs("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: [_jsx("span", { className: params.value }), params.value] }))); },
            width: 70,
        },
        {
            editable: false,
            field: "cotizacion",
            flex: 1,
            headerName: "Cotización",
            width: 150,
        },
        {
            editable: false,
            field: "poliza",
            flex: 1,
            headerName: "Poliza",
            width: 150,
        },
        {
            editable: false,
            field: "producto",
            flex: 1,
            headerName: "Producto",
            width: 150,
        },
        {
            editable: false,
            field: "plan",
            flex: 1,
            headerName: "Plan",
            width: 150,
        },
        {
            field: "prima",
            flex: 1,
            headerName: "Prima",
            width: 160,
        },
    ];
};
